// 非必要的情况不要放到 global.ts
// store.ts
import { GameListDto } from '@/services/game/provider';
import { createStore } from 'solid-js/store';

interface AppState {
  triggerAnimationTop: (times?: number) => void;
  showTabBar: boolean;
  gameList: GameListDto;
  taskCount: number;
}

const [globalState, setGlobalState] = createStore<AppState>({
  triggerAnimationTop: (times?: number) => {},
  showTabBar: true,
  gameList: {
    providerGameListResultItems : [],
  },
  taskCount: 0,
});

export { globalState, setGlobalState };